<div class="mds-panel" (click)="updateSelect()" [class.selected]="isSelected">
	<div class="mds-header">
		<img ada-decorative class="mds-image" [src]="imagePath" onerror="this.style.display = 'none'" />
		<div class="text-14-bold">{{ mdsScenario.groupName }}</div>
	</div>
	<div class="padding-bottom-15" *ngFor="let scenario of mdsScenario.scenarios">
		<span class="text-14">{{ scenario.name }}</span>
		<icon
			*ngIf="scenario.description"
			type="info-circle"
			class="info-circle text-14 padding-left-5"
			[tooltip]="infoBubble"
			[analytic-data]="{ linkName: 'tooltip_' + scenario.name }"
		></icon>
		<ng-template #infoBubble><section [innerHTML]="scenario.description"></section></ng-template>
	</div>
</div>
